export const NAME = 'ARTICLES';

export const articleUnfavourite = (store) => store[NAME].unfavourite.data;
